<template>
  <span
    class="relative block overflow-hidden bg-n-iris-2 before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-n-iris-4 before:to-transparent before:animate-shimmer"
  />
</template>
